import React from 'react';
import './style.scss';
import type { PriceInputProps } from 'views/mutual/priceInput';
import type { DateInputProps } from 'views/mutual/dateInput';
import { ApplyLotInputBody } from './domesticRealEstate/apply';
import { ITExplanationLotInputBody } from './domesticRealEstate/itExplanation';
import { LotInput_LeaseFund as LeaseFundLotInputBody } from './leaseFund';
import type { DomesticRealEstateSymbolDetailInfo } from 'views/utils/graphql/graphql';

type LotInputDataProps = {
  title: string;
  realEstateBeneficiaryRightPrice: number | null;
  realEstatePriceEquivalent: number | null;
  consumptionTaxAmount: number | null;
  repairReserveFundEquivalent: number | null;
  requiredWorkingCapitalReserveEquivalent: number | null;
};

type ApplyDomesticRealEstateProps = {
  priceInputProps?: PriceInputProps;
} & LotInputDataProps;

type ItExplanationDomesticRealEstateProps = {
  disabled: boolean | undefined;
  error: string | undefined;
  onChange: ((value: string) => void) | undefined;
  value: number | null | undefined;
  symbolDetail: DomesticRealEstateSymbolDetailInfo | null | undefined;
  showNotice: boolean;
} & LotInputDataProps;

type ConfirmationTitleProps = {
  title: string;
};

type LeaseFundLotInputProps = {
  interest: number | null;
  accruedInterest?: string | null;
  totalAmountRaw: number | null;
  disabled: boolean | undefined;
  error: string | undefined;
  onChange: ((value: string) => void) | undefined;
  value: number | null | undefined;
  amountOptionsRaw: Array<string | number>;
  step?: number | null;
  maxQuantity?: number | null;
  dateInputProps: DateInputProps;
};

export const LotInput_ApplyDomesticRealEstate = (props: ApplyDomesticRealEstateProps) => {
  return <ApplyLotInputBody {...props} />;
};

export const LotInput_ItExplanationDomesticRealEstate = (props: ItExplanationDomesticRealEstateProps) => {
  return <ITExplanationLotInputBody {...props} />;
};

export const LotInput_ConfirmationTitle = ({ title }: ConfirmationTitleProps) => {
  return <div className="lotInput_header">{title}</div>;
};

export const LotInput_LeaseFund = (props: LeaseFundLotInputProps) => {
  return <LeaseFundLotInputBody {...props} />;
};
